import { render } from "./IconSwitch.vue?vue&type=template&id=541ce8e8"
import script from "./IconSwitch.vue?vue&type=script&lang=ts"
export * from "./IconSwitch.vue?vue&type=script&lang=ts"
script.render = render

export default script